var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aroma-sleep-stage-chart"},[(_vm.series)?_c('div',{ref:"chart",staticClass:"aroma-sleep-stage-chart__canvas",attrs:{"role":"img","aria-label":"睡眠分期图"}}):_c('van-empty',{attrs:{"description":"暂无睡眠分期数据","image-size":"72"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }